"use client";

import { Statement } from "@jesus-central-church/ui";
import { SbBlokData, storyblokEditable } from "@storyblok/react/rsc";
import { SbStatement } from "@storyblok/types/287435740670216/storyblok-components";

export function StatementComponent({ blok }: { blok: SbStatement }) {
  const scriptures =
    blok.scriptures?.map((scripture) => ({
      scripture: scripture.scripture,
      reference: scripture.reference,
    })) ?? [];

  return (
    <Statement
      {...storyblokEditable(blok as SbBlokData)}
      subtitle={blok.subtitle}
      statement={blok.statement}
      scriptures={scriptures}
      textColor={blok.textColor as string}
    />
  );
}
